import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import { updateMediaElementAction } from 'editor/src/store/design/slice';
import { ElementAddress, MediaImage } from 'editor/src/store/design/types';
import { getLinkedCollectionElements } from 'editor/src/store/design/util/collectionLink';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import {
  buildAdvPersoPluginsUpdate,
  CollectionDisplayOption,
  getAdvPersoDataFromElement,
} from 'editor/src/store/plugins/utils/advPersoUtils';

// Linked layers share one display mode; changing it on any member fans out to every other
// member. Writes both plugin keys (via buildAdvPersoPluginsUpdate) so the change survives
// export — an in-place single-key mutation diverges the two keys under Immer.
const setCollectionDisplayOptionOperation =
  ({ address, displayOption }: { address: ElementAddress; displayOption: CollectionDisplayOption }) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const element = getMediaElement<MediaImage>(state, address);
    const data = element && getAdvPersoDataFromElement(element);
    if (!element || !data) {
      return;
    }

    dispatch(
      updateMediaElementAction({
        elementAddress: address,
        elementUpdate: { plugins: buildAdvPersoPluginsUpdate(element, { ...data, displayOption }) },
      }),
    );

    if (!data.linkGroupId || !state.design.designData) {
      return;
    }

    getLinkedCollectionElements(state.design.designData, data.linkGroupId).forEach((member) => {
      const isTarget =
        member.address.spreadIndex === address.spreadIndex &&
        member.address.pageIndex === address.pageIndex &&
        member.address.elementIndex === address.elementIndex;
      if (isTarget) {
        return;
      }
      dispatch(
        updateMediaElementAction({
          elementAddress: member.address,
          elementUpdate: {
            plugins: buildAdvPersoPluginsUpdate(member.element, { ...member.collectionInfo, displayOption }),
          },
        }),
      );
    });
  };

export default setCollectionDisplayOptionOperation;
